import type { PaymentType } from './api/types';

export const PAYMENT_NOTE: Record<PaymentType, string> = {
  now: 'A card will be required to guarantee this booking — collected securely at the next step.',
  hotel: 'Pay at the hotel — no card required now.',
  deposit: 'Payment handled by your agency.',
};

export const TOTAL_LABEL: Record<PaymentType, string> = {
  now: 'Total due now',
  hotel: 'Total — pay at hotel',
  // Pre-booking (View terms / Confirm): nothing has been charged yet, so this
  // must read as future/conditional — contrast PAID_TOTAL_LABEL below, which
  // is deliberately past-tense for the post-booking screens.
  deposit: 'Total',
};

/** Same three payment types, framed after the booking already exists
 * (Success, Profile → Bookings) rather than before submitting (Confirm). */
export const PAID_TOTAL_LABEL: Record<PaymentType, string> = {
  now: 'Total paid',
  hotel: 'Total — pay at hotel',
  deposit: 'Total paid',
};
